module.exports = __webpack_public_path__ + "img/41.1f2a89be.png";